import { useState, useEffect } from 'react';

const API_BASE_URL = process.env.REACT_APP_API_URL || 
  (window.location.hostname === 'localhost' 
    ? 'https://localhost:7292'
    : 'https://api.dotnethub.pl'
  );

interface UseMaintenanceModeReturn {
  isMaintenanceMode: boolean;
  checkMaintenanceMode: () => Promise<void>;
}

export const useMaintenanceMode = (): UseMaintenanceModeReturn => {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState<boolean>(false);

  const checkMaintenanceMode = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      });

      // Check if maintenance mode (503 Service Unavailable)
      if (response.status === 503) {
        setIsMaintenanceMode(true);
        return;
      }

      // If we get here, system is operational
      setIsMaintenanceMode(false);

    } catch (error) {
      // Network error or server down - treat as maintenance
      console.error('Failed to check maintenance mode:', error);
      setIsMaintenanceMode(true);
    }
  };

  // Check maintenance mode on mount
  useEffect(() => {
    checkMaintenanceMode();

    // Check every 30 seconds
    const interval = setInterval(checkMaintenanceMode, 30000);

    return () => clearInterval(interval);
  }, []);

  return {
    isMaintenanceMode,
    checkMaintenanceMode
  };
};
